// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.section-container[data-v-fc7db628]{display:flex;flex-direction:column;justify-content:flex-start;justify-content:var(--section-content-alignment,flex-start)}.section-text-actions.no-padding-bottom[data-v-fc7db628]{padding-bottom:0}.section-text-actions[data-v-fc7db628] .section-basic__title{margin-bottom:1.6rem}.buttons[data-v-fc7db628]{margin-top:4rem}.buttons[data-v-fc7db628] .action-item{padding:1.6rem 7.2rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
